import { useMemo } from 'react';
import { VariantProps } from 'tailwind-variants';
import { spinnerStyle } from './Spinner.style';

type SpinnerVariants = VariantProps<typeof spinnerStyle>;

export type SpinnerProps = {
  size?: number;
  strokeWidth?: number;
  className?: string;
  theme?: SpinnerVariants['theme'];
};

export const Spinner = ({
  size,
  strokeWidth = 3,
  theme,
  className
}: SpinnerProps) => {
  const spinnerClassNames = spinnerStyle({
    theme: theme
  });

  const style = useMemo(
    () => (size != null ? { width: `${size}px`, height: `${size}px` } : {}),
    [size]
  );

  return (
    <div
      className={spinnerClassNames.base({ className })}
      style={style}
      data-component="spinner"
    >
      <span
        className={spinnerClassNames.background()}
        style={{ borderWidth: `${strokeWidth}px` }}
      />
      <span
        className={spinnerClassNames.foreground()}
        style={{ borderWidth: `${strokeWidth}px` }}
      />
    </div>
  );
};
